import { ICompany, ICompanyOverview, PLAN_NAME } from '../../../lib/types';
import { IMultiSelectOption } from '../../_core/input/multiselect-input.component';

export enum RegisterCompanyOption {
  JOIN_WITH_CODE,
  REGISTER_FIRM,
  REGISTER_PERSONAL
}

export interface ICurrCompanyResult {
  company: ICompany;
}

export interface IEditRequestTypesProps {
  requestTypes: IMultiSelectOption[];
}

export interface IRegisterCompanyProps {
  name?: string;
  givenName?: string;
  familyName?: string;
  email?: string;
  phone?: string;
  planName: PLAN_NAME;
}

export interface IUpdateCompanyProps {
  name?: string;
  active?: boolean;
  completedOnboarding?: boolean;
  defaultPostSubmissionRedirectUrl?: string;
  logoAssetId?: string;
}

export interface IUserCompaniesResult {
  companies: ICompanyOverview[];
}
